import { css } from 'linaria';

export const THUMB_HEIGHT = 88;
export const THUMB_GAP = 8;
export const THUMB_COUNT = 4;
export const THUMB_COUNT_VIDEO = 3;
export const THUMB_SIZE = THUMB_HEIGHT + THUMB_GAP;

const HEIGHT = THUMB_HEIGHT * THUMB_COUNT_VIDEO;
const PLAY_ICON_TOP_POSITION = HEIGHT + 99;

const root = css`
  position: relative;
  margin-right: var(--space-450);
`;

const container = css`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1;
`;

const listWrapper = css`
  position: relative;
  z-index: 1;
  transition: transform 0.5s;
`;

const thumb = css`
  position: relative;
  display: block;
  height: ${THUMB_HEIGHT}px;
  width: ${THUMB_HEIGHT}px;
  margin-bottom: ${THUMB_GAP}px;
  padding: var(--space-100);
  box-sizing: border-box;
  border: 1px solid var(--control-secondary);
  border-radius: var(--rounding-m);
  cursor: pointer;

  &:hover {
    border: 1px solid var(--control-accent);
    transition: border 0.2s ease-out;
  }
`;

const videoThumbBg = css`
  position: absolute;
  top: var(--space-85);
  left: var(--space-85);
  width: 72px;
  height: 72px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-color: var(--control-primary);
`;

const thumbImageOutline = css`
  position: absolute;
  top: 0;
  left: 0;
  height: ${THUMB_HEIGHT}px;
  width: ${THUMB_HEIGHT}px;
  border: var(--space-25) solid var(--control-accent);
  border-radius: var(--space-50);
  z-index: 2;
  cursor: pointer;
  pointer-events: none;
`;

const arrow = css`
  position: absolute;
  left: 50%;
  display: flex;
  justify-content: center;
  z-index: 10;
  width: 40px;
  height: 40px;
  transform: translateX(-50%);
  background-color: var(--control-invert);
  box-shadow: var(--box-shadow-m);

  transition: opacity 0.2s ease 0s;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background-color: var(--control-invert);
  }
`;

const arrowTop = css`
  top: -20px;
`;

const arrowBottom = css`
  top: ${HEIGHT - 4}px;
`;

const videoThumbIcon = css`
  position: absolute !important;
  left: var(--space-225) !important;
  top: var(--space-225) !important;
  z-index: 2;
  svg {
    width: 32px;
    min-height: 32px;
    height: 32px;
  }
`;

const videoThumbIconBg = css`
  position: absolute;
  left: var(--space-250);
  top: var(--space-250);
  width: 20px;
  height: 20px;
  background-color: var(--control-primary);
`;

const playVideoWrapper = css`
  position: absolute;
  top: ${PLAY_ICON_TOP_POSITION}px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--control-minor);
  border-radius: 50%;
  cursor: pointer;
`;

const playVideo = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--text-primary);
`;

const playVideoIcon = css`
  width: 10px;
  height: 10px;
  transform: translateX(var(--space-10));
`;

export {
  arrow,
  arrowBottom,
  arrowTop,
  container,
  listWrapper,
  playVideo,
  playVideoIcon,
  playVideoWrapper,
  root,
  thumb,
  thumbImageOutline,
  videoThumbBg,
  videoThumbIcon,
  videoThumbIconBg,
};
